import { useTranslation } from "react-i18next"

const LocationSuccessModal = ({
  isOpen,
  onClose,
  newLocation,
  onContinue
}) => {
  const { t, i18n } = useTranslation()

  const handleContinue = () => {
    onContinue()
    onClose()
  }

  if (!isOpen) return null

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 3000,
        fontFamily: '"Red Hat Display", sans-serif',
        padding: "20px",
        boxSizing: "border-box",
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose()
        }
      }}
    >
      <div
        style={{
          background: "#FFFFFF",
          borderRadius: "20px",
          padding: "40px",
          maxWidth: "650px",
          width: "100%",
          maxHeight: "90vh",
          overflow: "auto",
          boxShadow: "0 20px 25px rgba(0, 0, 0, 0.1)",
          position: "relative",
          textAlign: "center",
        }}
        onClick={(e) => e.stopPropagation()}
        dir={i18n.dir()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: "8px",
            borderRadius: "8px",
            transition: "background 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#F9FAFB"
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "transparent"
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#6B7280"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        {/* Modal Content */}
        <div style={{ marginBottom: "32px" }}>
          {/* Success Icon */}
          <div
            style={{
              width: "60px",
              height: "60px",
              background: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px auto",
            }}
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 6L9 17l-5-5" />
            </svg>
          </div>

          {/* Title */}
          <h2
            style={{
              fontFamily: '"Red Hat Display", sans-serif',
              fontSize: "24px",
              fontWeight: 600,
              color: "#303E4E",
              margin: "0 0 16px 0",
              lineHeight: "1.3",
            }}
          >
            {t("locationSuccessModal.title")}
          </h2>

          {/* Description */}
          <p
            style={{
              fontFamily: '"Red Hat Display", sans-serif',
              fontSize: "16px",
              color: "#6B7280",
              margin: "0 0 32px 0",
              lineHeight: "1.5",
            }}
          >
            {t("locationSuccessModal.description", {
              newLocation: newLocation || t("locationSuccessModal.unknownLocation"),
            })}
          </p>

          {/* Continue Button */}
          <button
            onClick={handleContinue}
            style={{
              width: "200px",
              height: "48px",
              background: "#8548A8",
              color: "#FFFFFF",
              border: "none",
              borderRadius: "12px",
              fontFamily: '"Red Hat Display", sans-serif',
              fontSize: "16px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s ease",
              margin: "0 auto",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#7A4397"
              e.target.style.transform = "translateY(-1px)"
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "#8548A8"
              e.target.style.transform = "translateY(0)"
            }}
          >
            {t("locationSuccessModal.button")}
          </button>
        </div>
      </div>
    </div>
  )
}

export default LocationSuccessModal